var _rect, _path, _rect2, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCourseCongrats = function SvgCourseCongrats(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 258,
    viewBox: "0 0 460 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 460,
    height: 258,
    fill: "#F1F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101 258L359 0V258H101Z",
    fill: "#DDEEFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 359,
    width: 101,
    height: 258,
    fill: "#DDEEFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_3959_1498)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 40,
    width: 300,
    height: 178,
    rx: 8,
    fill: "#515478"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 48,
    width: 284,
    height: 162,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.5,
    y: 60.5,
    width: 259,
    height: 137,
    rx: 3.5,
    stroke: "#0A182E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 24,
    transform: "translate(100 60)",
    fill: "#0A182E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 99,
    width: 61,
    height: 4,
    rx: 2,
    fill: "#BFDAF4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 148,
    width: 43,
    height: 8,
    rx: 4,
    fill: "#BFDAF4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 109,
    width: 96,
    height: 2,
    rx: 1,
    fill: "#BFDAF4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 142,
    width: 21,
    height: 2,
    rx: 1,
    fill: "#BFDAF4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 115,
    width: 50,
    height: 2,
    rx: 1,
    fill: "#BFDAF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.933 76.5636V68.6152H126.414V71.8168H129.828V68.6152H131.309V76.5636H129.828V73.2088H126.414V76.5636H124.933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.973 70.9393V76.5769H136.561V75.853C136.205 76.4377 135.601 76.7439 134.792 76.7439C134.011 76.7439 133.366 76.4794 132.845 75.9365C132.324 75.3937 132.077 74.6837 132.077 73.765C132.077 72.8741 132.351 72.1503 132.886 71.6074C133.421 71.0645 134.052 70.7861 134.751 70.7861C135.588 70.7861 136.191 71.0506 136.561 71.5796V70.9253L137.973 70.9393ZM133.928 74.9343C134.23 75.2405 134.6 75.3937 135.066 75.3937C135.533 75.3937 135.889 75.2405 136.163 74.9343C136.424 74.6281 136.561 74.2383 136.561 73.7511C136.561 73.2778 136.424 72.8881 136.163 72.5679C135.903 72.2477 135.533 72.1085 135.066 72.1085C134.6 72.1085 134.23 72.2617 133.928 72.5679C133.627 72.8741 133.49 73.2639 133.49 73.7511C133.49 74.2383 133.627 74.6141 133.928 74.9343Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.267 72.7354V76.5774H142.855V73.3201C142.855 72.5127 142.471 72.109 141.731 72.109C141.36 72.109 141.045 72.2621 140.812 72.5545C140.579 72.8468 140.455 73.2365 140.455 73.6959V76.5634H139.043V70.9258H140.455V71.8306C140.908 71.1207 141.539 70.7588 142.334 70.7588C142.924 70.7588 143.39 70.9397 143.746 71.2877C144.089 71.6636 144.267 72.1369 144.267 72.7354Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.918 68.6289V76.5912H149.505V75.7977C149.355 76.0761 149.121 76.3128 148.82 76.4798C148.518 76.6608 148.162 76.7443 147.764 76.7443C146.982 76.7443 146.338 76.4798 145.817 75.9369C145.296 75.3941 145.049 74.6702 145.049 73.7654C145.049 72.8745 145.323 72.1507 145.872 71.6078C146.42 71.0649 147.051 70.7865 147.764 70.7865C148.587 70.7865 149.176 71.0649 149.519 71.6356V68.6289H150.918ZM146.9 74.9347C147.202 75.2409 147.572 75.3941 148.024 75.3941C148.477 75.3941 148.833 75.2409 149.108 74.9347C149.382 74.6284 149.519 74.2387 149.519 73.7515C149.519 73.2782 149.382 72.8884 149.108 72.5683C148.833 72.2481 148.477 72.1089 148.024 72.1089C147.572 72.1089 147.202 72.262 146.9 72.5683C146.598 72.8745 146.447 73.2643 146.447 73.7515C146.447 74.2387 146.598 74.6284 146.9 74.9347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.111 72.3315C153.111 72.6795 153.55 72.9579 154.414 73.1389C155.086 73.2781 155.579 73.4869 155.908 73.7653C156.224 74.0437 156.388 74.4195 156.388 74.8928C156.388 75.4218 156.183 75.8672 155.771 76.2152C155.36 76.5632 154.798 76.7302 154.085 76.7302C153.44 76.7302 152.905 76.5771 152.494 76.257C152.083 75.9368 151.754 75.547 151.548 75.0738L152.672 74.336C152.796 74.7118 152.988 75.0181 153.221 75.2408C153.468 75.4635 153.756 75.5749 154.098 75.5749C154.331 75.5749 154.537 75.5192 154.715 75.4078C154.894 75.2965 154.976 75.1434 154.976 74.9346C154.976 74.7536 154.88 74.6005 154.702 74.4891C154.523 74.3778 154.208 74.2803 153.797 74.1968C152.508 73.9323 151.863 73.3477 151.863 72.415C151.863 71.9 152.069 71.4963 152.467 71.2179C152.864 70.9256 153.358 70.7725 153.934 70.7725C154.551 70.7725 155.044 70.8838 155.415 71.1205C155.785 71.3571 156.087 71.7051 156.333 72.2062L155.223 72.8326C154.962 72.1645 154.537 71.8304 153.947 71.8304C153.385 71.8304 153.111 71.9974 153.111 72.3315Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.28 76.5772V68.6289H158.761V71.8305H162.189V68.6289H163.67V76.5772H162.189V73.2225H158.761V76.5772H157.28Z",
    fill: "#65DCA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.829 75.1853C172.364 74.4753 172.652 73.5984 172.652 72.6379C172.652 70.2854 170.951 68.5732 168.607 68.5732C166.262 68.5732 164.562 70.2854 164.562 72.6379C164.562 74.9904 166.262 76.7025 168.607 76.7025C169.416 76.7025 170.17 76.4937 170.801 76.1179L171.143 76.5633H172.857L171.829 75.1853ZM171.143 72.6379C171.143 73.0833 171.047 73.5149 170.883 73.8907L170.06 72.7771H168.319L169.937 74.9486C169.553 75.1853 169.1 75.2966 168.607 75.2966C167.112 75.2966 166.07 74.2109 166.07 72.6518C166.07 71.0928 167.112 70.007 168.607 70.007C170.101 69.9792 171.143 71.0788 171.143 72.6379Z",
    fill: "#65DCA4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.567 67.1191H124.59L114.925 76.9304L110.068 72.0001L112.58 69.4508L114.925 71.8317L119.567 67.1191ZM114.642 71.881L112.58 69.7875L110.517 71.881H114.642ZM110.517 72.1191H114.808V76.4746L110.517 72.1191ZM115.042 76.4746V72.1191H119.333L115.042 76.4746ZM119.733 71.7127V67.3572H124.024L119.733 71.7127ZM119.499 67.5256V71.881H115.208L119.499 67.5256Z",
    fill: "#65DCA4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 96,
    width: 90,
    height: 90,
    rx: 4,
    fill: "#F1F8FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_3959_1498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.803 198.006L348.684 200.185L345.438 229.796C345.344 230.652 344.286 230.997 343.705 230.362L337.236 223.28C336.546 222.525 335.399 222.411 334.575 223.016L327.15 228.469C326.448 228.984 325.469 228.419 325.564 227.554L328.803 198.006Z",
    fill: "#7F7EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.109 204.329L328.429 201.411L338 200.5L346.944 216.055L346.004 224.632L342.381 228.913L337.235 223.28C336.546 222.525 335.399 222.411 334.575 223.016L331.392 225.354C330.345 218.272 328.928 208.943 328.109 204.329Z",
    fill: "#5553F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M331.066 202.385L350.908 199.869L354.655 229.421C354.763 230.275 353.814 230.857 353.102 230.375L345.159 224.996C344.313 224.423 343.171 224.58 342.511 225.36L336.561 232.394C335.999 233.058 334.915 232.737 334.806 231.874L331.066 202.385Z",
    fill: "#7F7EFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338,
    cy: 178,
    r: 28,
    fill: "#FFC400"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M338 187L329.213 191.619C328.48 192.005 327.622 191.382 327.762 190.565L329.44 180.781L322.332 173.852C321.738 173.273 322.066 172.266 322.886 172.146L332.71 170.719L337.103 161.817C337.47 161.074 338.53 161.074 338.897 161.817L343.29 170.719L353.114 172.146C353.934 172.266 354.261 173.273 353.668 173.852L346.559 180.781L348.237 190.565C348.378 191.382 347.52 192.005 346.787 191.619L338 187Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_3959_1498",
    x: 52,
    y: 16,
    width: 356,
    height: 234,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3959_1498"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.0941176 0 0 0 0 0.180392 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3959_1498"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_3959_1498"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.0941176 0 0 0 0 0.180392 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3959_1498",
    result: "effect2_dropShadow_3959_1498"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3959_1498",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_3959_1498",
    x: 298,
    y: 140,
    width: 80,
    height: 106.749,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368627 0 0 0 0 0.439216 0 0 0 0 0.560784 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3959_1498"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368627 0 0 0 0 0.439216 0 0 0 0 0.560784 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3959_1498",
    result: "effect2_dropShadow_3959_1498"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3959_1498",
    result: "shape"
  })))));
};
export default SvgCourseCongrats;